import React, { useContext } from 'react'
import { authContext } from '../../Context/Authentication'
import { Navigate } from 'react-router-dom'

export default function ProtectedRoute(  {children} ) {

let {Token} =  useContext(authContext)


if(localStorage.getItem('__inventory_sys_auth_token_5f9dA72xQp__') !==null){
    return <>
    {children}
    </>


}else{
    return <Navigate to = {'/login'} />
}





}
